import React, { useEffect } from 'react';
import { api } from '../../hooks';

const SsoLogin = () => {
  useEffect(() => {
    api.iblwebauth.completeLogin();
  }, []);
};

export { SsoLogin };
